import React from "react";
import ECLBlock from "../ECLBlock";
import ECLBlockument from "../ECLBlockument";

export default function ReportBlock(props) {
   const reportKey = props.block.data.report_link.id + "_root";
   //Report has already been loaded, don't render
   if (props.headlist.includes(reportKey)) {
      return null;
   }

   if (Object.keys(props.flatDoc).includes(reportKey)) {
      //FlatDoc exists,
      return (
         <>
            {props.flatDoc[reportKey].children.map((c) => {
               return (
                  <ECLBlock
                     key={c + props.revision}
                     block={props.flatDoc[c]}
                     project={props.project}
                     flatDoc={props.flatDoc}
                     setFlatDoc={props.setFlatDoc}
                     flatKey={c}
                     headlist={[...props.headlist, reportKey]}
                     parentDoc={
                        props.parentDoc
                           ? props.parentDoc + props.flatKey
                           : props.flatKey
                     }
                     revisionCount={props.revisionCount}
                     incrementRevision={props.incrementRevision}
                     revision={props.revision}
                  />
               );
            })}
         </>
      );
   }
   return (
      <ECLBlockument
         project={props.project}
         object={{
            id: props.block.data.report_link.id,
            meta: {
               revisionId: props.block.data.report_link.rev,
               object_type: "report",
            },
         }}
         flatDoc={props.flatDoc}
         setFlatDoc={props.setFlatDoc}
         parent={
            props.parentDoc ? props.parentDoc + props.flatKey : props.flatKey
         }
         headlist={[...props.headlist, reportKey]}
      />
   );
}
